import React from 'react'
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Box,
  Text,
  Badge,
  VStack,
  HStack,
  Divider,
  IconButton,
  Heading,
  useColorModeValue,
} from '@chakra-ui/react'
import { InfoIcon } from '@chakra-ui/icons'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { Description } from './Description'
import { FinalizarChamado } from './FinalizarChamado'
import { ImageViewer } from './ImageViewer'

// Componente MaisDetalhes atualizado para aceitar controle externo do modal
export const MaisDetalhes = React.memo(
  ({
    item,
    children,
    // Props para controle externo do modal
    externalIsOpen = null,
    externalOnOpen = null,
    externalOnClose = null,
  }) => {
    // Se temos controles externos, usamos eles, caso contrário usamos o interno
    const internalDisclosure = useDisclosure()

    const isOpen = externalIsOpen !== null ? externalIsOpen : internalDisclosure.isOpen
    const onOpen = externalOnOpen || internalDisclosure.onOpen
    const onClose = externalOnClose || internalDisclosure.onClose

    const bgDescription = useColorModeValue('gray.50', 'gray.700')

    return (
      <>
        {children ? (
          <Box onClick={onOpen} cursor="pointer">
            {children}
          </Box>
        ) : (
          <IconButton icon={<InfoIcon />} size="sm" onClick={onOpen} aria-label="Mais detalhes" variant="ghost" colorScheme="blue" />
        )}

        {/* Modal de detalhes */}
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
          <ModalOverlay backdropFilter="blur(2px)" />
          <ModalContent>
            <ModalHeader>
              <HStack spacing={2}>
                <Text>Chamado #{item.numero_chamado}</Text>
                <Badge colorScheme={item.tipo_chamado === 'Alta' ? 'red' : 'blue'}>{item.tipo_chamado}</Badge>
              </HStack>
              {item.titulo && (
                <Text fontSize="md" fontWeight="normal" mt={1} color="gray.600">
                  {item.titulo}
                </Text>
              )}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack align="start" spacing={4}>
                <Box width="100%">
                  <Text fontWeight="bold" fontSize="sm" color="gray.500">
                    Solicitante
                  </Text>
                  <Text>{item.solicitante}</Text>
                </Box>

                <Box width="100%">
                  <Text fontWeight="bold" fontSize="sm" color="gray.500">
                    Data de abertura
                  </Text>
                  <Text>{format(new Date(item.data_abertura), 'PPPp', { locale: ptBR })}</Text>
                </Box>

                <Box width="100%">
                  <Text fontWeight="bold" fontSize="sm" color="gray.500">
                    Prioridade
                  </Text>
                  <Badge
                    colorScheme={
                      item.prioridade === 'Alta' || item.prioridade === 'Muito alta' ? 'red' : item.prioridade === 'Media' ? 'yellow' : 'green'
                    }
                  >
                    {item.prioridade}
                  </Badge>
                </Box>

                <Box width="100%">
                  <Text fontWeight="bold" fontSize="sm" color="gray.500">
                    Responsável
                  </Text>
                  <Badge
                    colorScheme={
                      item.responsavel === 'FRONT'
                        ? 'blue'
                        : item.responsavel === 'BACK'
                          ? 'purple'
                          : item.responsavel === 'BANCO'
                            ? 'orange'
                            : 'gray'
                    }
                  >
                    {item.responsavel || 'Não definido'}
                  </Badge>
                </Box>

                {item.link_imagem && (
                  <Box width="100%">
                    <Text fontWeight="bold" fontSize="sm" color="gray.500" mb={2}>
                      Captura de Tela
                    </Text>
                    <ImageViewer imageUrl={item.link_imagem} alt={`Captura de tela do chamado #${item.numero_chamado}`} />
                  </Box>
                )}

                <Divider />

                <Box width="100%">
                  <Heading size="sm" color="blue.600" mb={2}>
                    Descrição do Problema
                  </Heading>
                  <Box p={4} bg={bgDescription} borderRadius="md" borderLeft="4px solid" borderColor="blue.500">
                    {item.detalhes_problema ? (
                      <Text whiteSpace="pre-wrap">{item.detalhes_problema}</Text>
                    ) : (
                      <Text color="gray.500" fontStyle="italic">
                        Sem descrição detalhada
                      </Text>
                    )}
                  </Box>
                </Box>
              </VStack>
            </ModalBody>

            <ModalFooter justifyContent="space-between">
              <Button colorScheme="blue" onClick={onClose}>
                Fechar
              </Button>

              {/* Integrando o botão de finalizar diretamente no modal de detalhes */}
              <FinalizarChamado item={item} insideModal={true} />
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }
)
